import React from "react";
import Checkbox from "@/components/ui/checkbox/Checkbox";
import { FacetItem } from "@/common/lib/types";

export interface ColorListProps {
  facet: FacetItem[];
  selectedValues: string[];
  translations: { singleItem: string; multipleItem: string };
  onClick: (value: string) => void;
}

const ColorList = ({ facet, selectedValues, translations, onClick }: ColorListProps) => {
  const handleChange = (color: string) => {
    onClick(color);
  };

  return facet?.map((color, index) => {
    return (
      <React.Fragment key={index}>
        <div
          className="flex cursor-pointer items-center justify-between p-4"
          onClick={() => handleChange(color?.value)}
        >
          <div className="flex items-center">
            <div
              className={`me-2 h-4 w-4 rounded-full`}
              style={{ backgroundColor: color?.hexCode }}
            />
            <p className="text-sm">{color?.label || ""}</p>
          </div>
          <div className="flex items-center">
            <p className="me-2 text-xs text-tertiary-6">
              {color?.count > 1
                ? translations?.multipleItem?.replace("{{count}}", `${color?.count}`)
                : translations?.singleItem?.replace("{{count}}", `${color?.count}`)}
            </p>
            <Checkbox
              checked={selectedValues?.includes(color?.value)}
              className="h-4 w-4 border-[#C4C4C4] checked:bg-[#4285F4] hover:bg-white hover:checked:bg-[#4285F4] focus:checked:bg-[#4285F4]"
              onChange={() => {}}
            />
          </div>
        </div>
        <div className="mx-4 h-[1px] bg-tertiary-7" />
      </React.Fragment>
    );
  });
};

export default ColorList;
